import axios from '@/app/shared/config/interceptor'

const PREFIX = '/cards'

export default {

  getAllHistories (cardId) {
    return axios.get(`${PREFIX}/${cardId}/histories`)
  }
}
